import Raven from 'raven-js'

const IS_PRODUCTION = process.env && process.env.NODE_ENV === 'production'

export const initialize = SENTRY_PUBLIC_DSN => {
  if (SENTRY_PUBLIC_DSN) {
    Raven.config(SENTRY_PUBLIC_DSN).install()
  }
}

export const log = (title = '', data = {}) => {
  // append statusCode in title for better logs
  if (data && data.error && data.error.statusCode) {
    title += ` - ${data.error.statusCode}`
  }

  console.log('log', { title, data })

  if (!IS_PRODUCTION) return

  const context = Raven.getContext()
  const userId = context && context.user && context.user.id

  if (userId) {
    title += ` (user_id: ${userId})`
  }

  Raven.captureMessage(title, {
    extra: data
  })
}

export const setContext = ({ user, ...context } = {}) => {
  if (!IS_PRODUCTION) return

  if (user) {
    Raven.setUserContext({
      id: user.id,
      email: user.email,
      username: user.username,
      name: user.name,
      is_completed: user.is_completed,
      lang: user.lang
    })

    return
  }

  Raven.setExtraContext(context)
}
